import React from 'react';
import { ConfirmationModal, Typography } from 'seagull';
import { useStoreActions } from "../../../contexts";
import RestfulWrapper from "../../../components/RestfulWrapper/RestfulWrapper";
import { useSendReminder } from "../../../hooks/useSendReminder";
import MissingSignaturesRecipients from "../../../components/MissingSignaturesRecipients/MissingSignaturesRecipients";
const MissingSignaturesReminderModalBody = _ref => {
  let {
    relationship
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "send-proposal-approval-reminder-modal"
  }, /*#__PURE__*/React.createElement(Typography, null, "An email reminder will be sent to recipients who need to sign:"), /*#__PURE__*/React.createElement(MissingSignaturesRecipients, {
    relationship: relationship
  }));
};
const MissingSignaturesReminderModal = _ref2 => {
  let {
    relationship,
    dismissModal
  } = _ref2;
  const {
    sendReminder
  } = useSendReminder();
  const sendReminderWrapped = () => {
    sendReminder(relationship);
    dismissModal();
  };
  return /*#__PURE__*/React.createElement(ConfirmationModal, {
    textAlignCenter: false,
    title: "Send reminder",
    primaryButtonLabel: "Send now",
    primaryButtonTestid: "send-propposal-approval-reminder-button",
    secondaryButtonLabel: "Back",
    secondaryButtonTestid: "cancel-send-propposal-approval-reminder-button",
    onCloseButtonClick: dismissModal,
    onPrimaryButtonClick: sendReminderWrapped,
    onSecondaryButtonClick: dismissModal,
    content: /*#__PURE__*/React.createElement(MissingSignaturesReminderModalBody, {
      relationship: relationship
    })
  });
};
const WrappedMissingSignaturesReminderModal = props => {
  const {
    api
  } = useStoreActions();
  async function fetchData() {
    return await api.relationship.get(props.relationshipId);
  }
  return /*#__PURE__*/React.createElement(RestfulWrapper, {
    fetch: fetchData,
    renderChild: _ref3 => {
      let {
        data: relationship
      } = _ref3;
      return /*#__PURE__*/React.createElement(MissingSignaturesReminderModal, {
        dismissModal: props.dismissModal,
        relationship: relationship
      });
    }
  });
};
export default WrappedMissingSignaturesReminderModal;